module.exports = {"513423001":"盐井街道","513423101":"卫城镇","513423102":"梅雨镇","513423103":"白乌镇","513423104":"树河镇","513423105":"黄草镇","513423106":"平川镇","513423107":"泸沽湖镇","513423108":"官地镇","513423109":"梅子坪镇","513423110":"润盐镇","513423111":"长柏镇","513423112":"甲米镇","513423113":"棉桠镇","513423114":"盐塘镇","513423115":"金河镇","513423116":"龙塘镇","513423117":"兴隆镇","513423206":"藤桥乡","513423207":"田湾乡","513423215":"右所乡","513423222":"沃底乡","513423223":"大坡蒙古族乡","513423224":"洼里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513423.json
// module id = 2564
// module chunks = 0